import { trans, plainTrans } from "@mongez/localization";
import { TextInput } from "../../design-system/components/Form";
import { useCodePayment } from "../hooks";

export function CodePayment() {
  const { updateCode } = useCodePayment();

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="text-center">
        <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-green-100 dark:bg-green-900/30">
          <svg
            className="h-8 w-8 text-green-600 dark:text-green-400"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
            />
          </svg>
        </div>
        <h3 className="mb-2 text-xl font-semibold text-gray-900 dark:text-gray-100">
          {trans("checkout.unlockWithCode")}
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-300">
          {trans("checkout.enterUnlockCode")}
        </p>
      </div>

      {/* Code Input */}
      <div className="space-y-4">
        <div>
          <label
            htmlFor="unlock-code"
            className="mb-2 block text-sm font-medium text-gray-700 dark:text-gray-300"
          >
            {trans("checkout.unlockCode")}
          </label>
          <div className="relative">
            <TextInput
              id="unlock-code"
              type="text"
              name="code"
              onChange={updateCode}
              placeholder={plainTrans("checkout.enterCodePlaceholder")}
              className="text-center font-mono text-lg uppercase tracking-wider"
              maxLength={20}
              autoComplete="off"
            />
          </div>
        </div>
      </div>
      {/* Instructions */}
      <div className="rounded-lg border border-blue-200 dark:border-blue-700 bg-blue-50 dark:bg-blue-900/20 p-4">
        <div className="flex items-start space-x-3">
          <svg
            className="mt-0.5 h-5 w-5 flex-shrink-0 text-blue-600 dark:text-blue-400"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
          <div>
            <h4 className="text-sm font-medium text-blue-900 dark:text-blue-100">
              {trans("checkout.howToUseCode")}
            </h4>
            <ul className="mt-2 space-y-1 text-sm text-blue-800 dark:text-blue-200">
              <li>• {trans("checkout.codeInstruction1")}</li>
              <li>• {trans("checkout.codeInstruction2")}</li>
              <li>• {trans("checkout.codeInstruction3")}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
